export default __webpack_public_path__ + "static/media/icon_checkbox_on.ab2ce1f2.svg";